const fallbackPath = (menu) => '/' + (menu && menu.code ? menu.code : '')

export const normalizeMenuPath = (path) => {
  const raw = String(path || '').trim()
  const segments = raw.split('/').filter(Boolean)
  return segments.length ? '/' + segments.join('/') : '/'
}

export const getMenuPathSegment = (menu) => {
  const normalized = normalizeMenuPath(menu && menu.path ? menu.path : fallbackPath(menu))
  const segments = normalized.split('/').filter(Boolean)
  return segments.length ? segments[segments.length - 1] : (menu && menu.code ? menu.code : '')
}

export const resolveMenuPath = (menu, parentMenu) => {
  const current = normalizeMenuPath(menu && menu.path ? menu.path : fallbackPath(menu))
  if (!parentMenu) {
    return current
  }

  const parent = normalizeMenuPath(parentMenu.path || fallbackPath(parentMenu))
  if (current === parent || current.startsWith(parent + '/')) {
    return current
  }

  if (current === '/') {
    return parent
  }

  return normalizeMenuPath(parent + '/' + current.replace(/^\/+/, ''))
}
